import React, { Component } from 'react';
import "./ManagerPage.css";
import { withFirebase } from "../../Firebase";
import { withRouter } from "react-router-dom";
import userProfilImage from "../../assets/icon_user_profile.svg";
import { ProfileCard } from "../Peers/PeersPage"
import close_icon from "../../assets/left-arrow-black.svg";

class ManagerPage extends Component {
  componentDidMount() {
    document.body.style.background = "white";
  }

  onClose = () => {
    return this.props.history.goBack()
  }

  render() {
    return (
      <div className="manager-background">
        <img className="back_arrow cursor-pointer" onClick={this.onClose} src={close_icon} alt="back" />
        <ManagerPageBaseB />
      </div>
    );
  }
}

const INITIAL_STATE = {
  manager: [],
  new_manager: '',
  current_user: null,
  current_uid: null,
  users: null,
  managerID: '',
  hideManager: false,
  matchingManager: [],
};

class ManagerPageBase extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE, };
  }

  componentDidMount() {
    document.body.style.backgroundColor = "white";
    if (this.props.firebase.auth.currentUser) {
      this.refreshManager();
    }
  }

  refreshManager() {
    let uid = this.props.firebase.auth.currentUser.uid
    this.setState({ current_uid: uid });
    this.props.firebase.db
      .collection('users')
      .doc(uid)
      .get()
      .then((doc) => {
        if (doc.exists) {
          const cu = doc.data();
          this.setState({ current_user: cu, managerID: doc.data().manager });
        }
      }).then(() => {
        this.props.firebase.db
          .collection('users')
          .doc(this.state.managerID)
          .get()
          .then((doc) => {
            if (doc.exists) {
              const current_manager = doc.data();
              this.setState({ manager: current_manager, new_manager: '' });
            }
          })
      })
      .then(() => {
        this.props.firebase.db.collection('users').where('company', '==', this.state.current_user.company)
          .get()
          .then(querySnapshot => {
            const users = querySnapshot.docs.map(doc => doc);
            this.setState({
              users: users
            })
          })
      })
      .catch((error) => {
        console.error("Error getting document:", error);
      });
  }

  onChange = event => {
    if (event.target.name === "manager") {
      this.setState({ hideManager: true });
      let user = event.target.value;
      let matchingUsers = this.state.users.filter(userselect => (userselect.data().firstname + userselect.data().lastname).toLowerCase().includes(user.toLowerCase()))
      matchingUsers.sort((a, b) => {
        if (a.data().lastname.toLowerCase() < b.data().lastname.toLowerCase()) {
          return -1
        }
        if (a.data().lastname.toLowerCase() > b.data().lastname.toLowerCase()) {
          return 1
        }
        return 0
      })
      if (matchingUsers.length > 0) {
        this.setState({ showUsers: true, matchingManager: matchingUsers, new_manager: event.target.value })
      }
    }
    this.setState({ [event.target.name]: event.target.value });
  }

  onSelectManager = (user) => {
    const { current_uid } = this.state;
    this.setState({ new_manager: (user.data().firstname + ' ' + user.data().lastname), manager: user.id });
    this.props.firebase.user(current_uid).set({ manager: user.id }, { merge: true })
    this.refreshManager();
    this.setState({ hideManager: false, showUsers: false });
  }

  render() {
    const {
      manager,
      new_manager,
      showUsers,
      hideManager,
      matchingManager,
    } = this.state;
    const context = this;

    return (
      <div className="container">
        <h1 className="text-center title_manager">Mon responsable</h1>
        <div className="row text-center center-content mb-5">
          <div className="custom-text-manager form-group">
            <p className="custom-text-responsable">Sélectionnez un responsable pour trouver votre constellation</p>
            <input
              className="custom-input-responsable"
              name="manager"
              value={new_manager}
              onChange={this.onChange}
              type="text"
              placeholder="Recherche un email ou un nom"
            />
            <div hidden={!(showUsers === true)} className="form-group edit-manager-selection">
              {matchingManager.map((user) => <div onClick={() => this.onSelectManager(user)} className="suggested-manager mt-3 text-center" key={user.id}>
                <img
                  alt="icon"
                  className="picture-compagny"
                  src={user.data().image_url_profile !== null ? user.data().image_url_profile : userProfilImage}
                  onError={context.props.firebase.profileImgError}
                ></img>
                <h3 key={user.data().firstname} value={user.data().firstname}>{user.data().firstname} {user.data().lastname}</h3>
              </div>)}
            </div>
          </div>
        </div>
        <div className="row text-center">
          <div className="col-sm-1 col-md-1"></div>
          <div className="col-sm-12  col-md-10 flex-test">
            <div hidden={!(hideManager === false)}>
              <div className="mr-3 mb-5">
                <ProfileCard
                  image_profile={manager.image_url_profile ? manager.image_url_profile : userProfilImage}
                  firstname={manager.firstname}
                  lastname={manager.lastname}
                  position={manager.position ? manager.position : "Poste non renseigné"} />
              </div>
            </div>
          </div>
          <div className="col-sm-1 col-md-1"></div>
        </div>
      </div>
    );
  }
}

const ManagerPageBaseB = withRouter(withFirebase(ManagerPageBase));
export { ManagerPageBaseB };

export default ManagerPage;